import { BulkTradeMode } from "../../../../Wrap/Models/Models/Instruments/BulkTradeMode";

export const InsuredFundArray = [BulkTradeMode.BulkSell, BulkTradeMode.BulkSwitch];

export const InsuredFundMap = {
    [BulkTradeMode.BulkSell] : "Sell",
    [BulkTradeMode.BulkSwitch] : "Switch"
};

export const ContentFilter = {
    title: "Search insured fund criteria",
    validate: "Validate",
    fundCode: "FundCode"
};